import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQuery,
  CREATE_TRADE_DATA,
  DELETE_TRADE_DATA,
  GET_ALL_TRADEDATA_LOGS,
  GET_ALL_TRADEDATA_REAL,
} from "@/graphql";
interface TradeDataLogsReponse {
  getTasksByTenant: TradeDataLogsTypes;
}
interface PostTradeDataResponse {
  createTradeData: {
    data: string;
  };
}

export const tradeDataApi = createApi({
  reducerPath: "api/tradeData",
  tagTypes: ["tradeData", "tradeDataLogs"],
  baseQuery,
  endpoints: (builder) => ({
    getAllTradeData: builder.query<
      TradeDataResponse,
      {
        pageNo: number;
        pageSize: number;
        sortBy?: string;
        sortType?: number;
        clientId?: string;
        searchKeyword?: string;
      }
    >({
      query: (variables) => ({
        document: GET_ALL_TRADEDATA_REAL,
        variables: { ...variables },
      }),
      providesTags: ["tradeData"],
      transformResponse: (response: TradeDataResponse) => response,
    }),
    postTradeData: builder.mutation<
      PostTradeDataResponse["createTradeData"],
      CreateTradeDataDTO
    >({
      query: ({ tradeData }) => ({
        document: CREATE_TRADE_DATA,
        variables: { tradeData },
      }),
      invalidatesTags: ["tradeData"],
      transformResponse: (response: PostTradeDataResponse) =>
        response.createTradeData,
    }),
    getAllTradeDataLogs: builder.query<
      TradeDataLogsReponse["getTasksByTenant"],
      {
        input: {
          clientId: string;
          uploadTime: string;
        };
      }
    >({
      query: (variables) => {
        return {
          document: GET_ALL_TRADEDATA_LOGS,
          variables: { ...variables },
        };
      },
      providesTags: ["tradeDataLogs"],
      transformResponse: (response: TradeDataLogsReponse) => {
        return response.getTasksByTenant;
      },
    }),
    deleteTradeData: builder.mutation<
      DeleteTradeDataResponse["deleteAllTradeData"],
      DeleteTradeDataVariables
    >({
      query: ({ tenantId, clientId }) => ({
        document: DELETE_TRADE_DATA,
        variables: { tenantId, clientId },
      }),
      invalidatesTags: ["tradeData"],
      transformResponse: (response: DeleteTradeDataResponse) => response.deleteAllTradeData,
    }),
  }),
});

export const {
  useGetAllTradeDataQuery,
  useLazyGetAllTradeDataQuery,
  usePostTradeDataMutation,
  useDeleteTradeDataMutation,
  // Logs api
  useGetAllTradeDataLogsQuery,
  useLazyGetAllTradeDataLogsQuery,
} = tradeDataApi;
